// extracted by css-extract-rspack-plugin
export default {"datePicker":"veuqG","selectBoxContainer":"YKMdn","selectBox":"vEryJ"};